import { Deserializable } from '../interfaces';

export class ProgramaDTO implements Deserializable {
  programaID?: string;
  nombre?: string;
  sufijo?: string;

  constructor() {
    this.programaID = '';
    this.nombre = '';
    this.sufijo = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
